/**
 * Created by Christof Sander on 03.03.2017.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'table',
		'table'
	],

	config: {
		showFilter: true,
		isSortable: true,
		isSelectable: true,
		showPaging: true,
		multiSelect: true
	},

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(this.actions[baseActionKey]){
				return this.performAction(
					this.prepareAction(baseActionKey)
				);
			}

			return utils.promise.reject();
		},
		showEdit: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(this.actions[baseActionKey] && additionalData.rowData){
				return this.performAction(
					this.prepareAction(baseActionKey, additionalData.rowData.attributes[additionalData.rowData.primaryKey])
				);
			}

			return utils.promise.reject();
		},
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;

			if(self.actions[baseActionKey] && additionalData.rowData){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
						message:    storage.__('hint.delete.really.' + buttonContext + '.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(
							self.prepareAction(baseActionKey, additionalData.rowData.attributes[additionalData.rowData.primaryKey])
						).then(function(context){
							return utils.promise.resolve(context);
						});
					}
				});
			}

			return utils.promise.reject();
		},
		duplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(this.actions[baseActionKey] && additionalData.rowData){
				return this.performAction(
					this.prepareAction(baseActionKey, additionalData.rowData.attributes[additionalData.rowData.primaryKey])
				);
			}

			return utils.promise.reject();
		},

		sanitizeResources: function(){
			this.onResourceSanitized();
		}
	}
};
